import React from "react";

const Button = ({
  text,
  primary,
  icon,
  className,
  onClick,
  isDisabled,
  type = "button",
  width = "w-[7.5rem]",
  textColor = "text-white",
  textColorDefault = "text-black",
  bgColor = "bg-white",
  borderColor = "border-black border",
  paddingButton = "p-[6px]",
  margin = "mr-2",
  disabledTextColor = "text-[#707070]",
  ...rest
}) => {
  return (
    <button
      disabled={isDisabled}
      onClick={onClick}
      type={type}
      className={`justify-center text-center ${margin} ${paddingButton} ${width} rounded-[4px] ${
        isDisabled
          ? `bg-[#dddddd] ${disabledTextColor} border border-[#cccccc] cursor-not-allowed`
          : primary
          ? `bg-primary-blue border border-primary-blue ${textColor}`
          : `${textColorDefault}  ${borderColor} ${bgColor}`
      } 
      ${icon ? "flex gap-3 items-center " : ""} ${className}`}
      {...rest}
    >
      {icon ? icon : null}
      {text}
    </button>
  );
};

export default Button;
